<template>
  <header :class="{'app-header--white': isWhiteHeader}">
    <div
      class="app-header"
      :class="{
        'app-header--transparent': isTransparent && isAtTop,
        'hidden-navbar': !showNavbar,
        fixed: !headerIsNotFixed,
        relative: headerIsNotFixed,
      }"
    >
      <div class="xl:block hidden">
        <HeaderTopDesktop ref="headerTopDesktop" />
        <HeaderCategoriesDesktop v-if="hasCategory" />
      </div>
      <div class="xl:hidden">
        <HeaderTopMobile
          ref="headerMobile"
          @emitOpenSearchBox="isOpenSearch = true"
        />
        <slot
          name="search-box"
          :show="isOpenSearch"
        />
      </div>
    </div>
    <!-- todo check for header !headerIsNotFixed-->
    <div
      :class="'app-header__space'+spaceClass"
    />
  </header>
</template>

<script>
import debounce from 'lodash/debounce'
import HeaderTopDesktop from '@library/ui/header/header-top/desktop'
import HeaderTopMobile from '@library/ui/header/header-top/mobile'
import HeaderCategoriesDesktop from '@library/ui/header/header-categories/desktop'

export default {
  name: 'AppHeader',
  components: {
    HeaderTopMobile,
    HeaderTopDesktop,
    HeaderCategoriesDesktop
  },
  provide () {
    const allProps = {}
    Object.defineProperty(allProps, 'data', {
      enumerable: true,
      get: () => {
        return this.$props
      }
    })
    return {
      allProps
    }
  },
  props: {
    hasCategory: {
      type: Boolean,
      default: true
    },
    linksHeaderTop: {
      type: Object,
      default: () => {
      }
    },
    ostadbankSupportPhone: {
      type: [String, Number],
      default: ''
    },
    auth: {
      type: Object,
      default: () => {
      }
    },
    spaceClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isOpenSearch: false,
      handleDebouncedScroll: null,
      showNavbar: true,
      lastScrollPosition: 0,
      scrollValue: 0,
      isAtTop: false
    }
  },
  computed: {
    headerIsNotFixed () {
      return false // this.getRouteBaseName() === this.$routeName.start_teaching;
    },
    isTransparent () {
      if (this.getRouteBaseName() === this.$routeName.tutor_package_list || this.getRouteBaseName() === this.$routeName.tutor_package_intro) {
        return true
      } else {
        return false
      }
    },
    isWhiteHeader () {
      if (this.getRouteBaseName() === this.$routeName.tutor_package_intro) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    this.lastScrollPosition = window.pageYOffset
    this.handleScroll()
    this.handleDebouncedScroll = debounce(this.handleScroll, 100)
    window.addEventListener('scroll', this.handleDebouncedScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleDebouncedScroll)
  },
  methods: {
    closeSearchBox () {
      // this.closeSearch();
      this.isOpenSearch = false
      if (this.$refs.headerMobile) {
        if (this.$refs.headerMobile.hasOwnProperty('closeSearchBox')) {
          this.$refs.headerMobile.closeSearchBox()
        }
      }
    },
    handleScroll () {
      if (window.pageYOffset < 0) {
        return
      } else if (window.pageYOffset === 0) {
        this.isAtTop = true
      } else {
        this.isAtTop = false
      }
      this.$emit('updateOffsetTopWindows', window.pageYOffset)
      this.closeSearchBox()
      // TODO check error this line
      // this.$refs.headerTopDesktop.closeSearch()
      if (Math.abs(window.pageYOffset - this.lastScrollPosition) < 50) {
        return
      }
      this.showNavbar = window.pageYOffset < this.lastScrollPosition
      this.$emit('updateDisplayNavbar', this.showNavbar)
      this.lastScrollPosition = window.pageYOffset
    }
  }
}
</script>

<style lang="scss">
.app-header {
  @apply bg-white border xl:border-none border-gray-light    inset-x-0;
  z-index: 9999;

  &__space {
    height: 56px;
    @screen xl {
      height: 132px;
    }
  }
  &__space__forum {
    height: 56px;
    @screen xl {
      height: 64px;
    }
  }

  transform: translate3d(0, 0, 0);
  transition: 0.2s all cubic-bezier(0.25, 0.46, 0.45, 0.94);

  &.hidden-navbar {
    box-shadow: none;
    transform: translate3d(0, -100%, 0);
  }

  &--transparent{
    @apply bg-transparent border-0;
  }
  &--white{
    @apply bg-white;
    .app-header--transparent{
      @apply border;
    }
  }
}
</style>
